import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "sw_session_id";

function getSessionId() {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s = `s_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    return null;
  }
}

export default function VisitTracker() {
  const { pathname } = useLocation();
  const lastLogged = useRef("");

  useEffect(() => {
    // Never track admin dashboard views
    if (pathname.startsWith("/admin")) return;
    // Dedupe rapid re-renders of the same path
    if (lastLogged.current === pathname) return;
    lastLogged.current = pathname;

    axios
      .post(`${API}/visits`, {
        path: pathname,
        referrer: document.referrer || null,
        session_id: getSessionId(),
      })
      .catch(() => {/* silent — visit tracking is best-effort */});
  }, [pathname]);

  return null;
}
